import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicPartnersBondAuthority({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 80 80"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M37.809 4.906a5 5 0 014.382 0l31 15.112A5 5 0 0176 24.512v12.776a5 5 0 01-5 5l-5-.001v25h6a4 4 0 110 8H8a4 4 0 110-8h6v-25H9a5 5 0 01-4.995-4.783L4 37.288V24.513a5 5 0 012.809-4.495zM36 42.287H22v25h14v-25zm22 0H44v25h14v-25zm-18-29.55l-28 13.65v7.9h56v-7.9l-28-13.65zm0 7.55a5 5 0 110 10 5 5 0 010-10z"
        fill="#F4F5FB"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgPicPartnersBondAuthority.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicPartnersBondAuthority.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicPartnersBondAuthority svgRef={ref} {...props} />
));
export default ForwardRef;
